'use strict';

var _ = require('lodash');

/*
    The domain formats we accept as part of a valid S3 bucket URL are:
        <bucket-name>.s3-<aws-region>.amazonaws.com
            ex.  test-bucket-s3.us-west-2.amazonaws.com
        <bucket-name>.s3.<aws-region>.amazonaws.com
            ex.  test-bucket.s3.us-west-2.amazonaws.com
        <bucket-name>.s3-<2-letter-country-code>-gov-<aws-region>-<number>.amazonaws.com
            ex.  test-bucket.s3-us-gov-west-2.amazonaws.com
        <bucket-name>.s3.<2-letter-country-code>-gov-<aws-region>-<number>.amazonaws.com
            ex.  test-bucket.s3.us-gov-west-2.amazonaws.com
        <bucket-name>.s3.amazonaws.com
 */
var regionRegexExpression = '^(.+)\\.s3([-.][a-z]{2}(-gov)?-[a-z]+-[0-9])?\\.amazonaws\\.com$';
var regionRegex = new RegExp(regionRegexExpression);

module.exports = function (domain) {
    var match = regionRegex.exec(domain);
    if (!_.isNull(match)) {
        //the first match group is the entire string while [1] is the bucketName
        return match[1];
    } else {
        return null;
    }
};